import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  privateKey = 'arodit-core';
  encrypt(data) {
    if (data) {
      if (!_.isString(data)) {
        data = JSON.stringify(data);
      }

      data = crypto['AES'].encrypt(data, this.privateKey);
      data = data.toString();
    }
    return data;
  }

  decrypt(data) {
    if (data) {
      const bytes = crypto['AES'].decrypt(data, this.privateKey),
        byteString = bytes.toString(crypto['enc'].Utf8);

      if (byteString !== '') {
        data = JSON.parse(byteString);
      }
    }

    return data;
  }
}
